import SortIcon from "@uui/ArrowsDown";
import { shallow } from "zustand/shallow";

import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";
import { MenuButton } from "@app/analytics/TopicReport/styles";
import { TopicReportTakeawaysSortOrder } from "@app/analytics/TopicReport/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import DropdownMenuItem from "@rui/Dropdown/DropdownMenuItem";
import { getSelectedFromOptions } from "@rui/Dropdown/utils";
import Menu from "@rui/Menu";

const SORT_OPTIONS: { value: TopicReportTakeawaysSortOrder; label: string }[] =
  [
    {
      value: "rank",
      label: "Most relevant",
    },
    {
      value: "date",
      label: "Most recent",
    },
  ];

const TakeawaysSortMenu = ({ disabled }: { disabled: boolean }) => {
  const { anchorEl, onClick, onClose, open } = useAnchorElement();

  const [sortOrder, setSortOrder] = useTopicReportStore(
    (state) => [state.takeawaysSortOrder, state.setTakeawaysSortOrder],
    shallow
  );

  const selectedSort = getSelectedFromOptions(SORT_OPTIONS, sortOrder);

  const handleChangeSort = (value: TopicReportTakeawaysSortOrder) => () => {
    setSortOrder(value);
    onClose();
  };

  return (
    <>
      <MenuButton disabled={disabled} onClick={onClick} endIcon={<SortIcon />}>
        {selectedSort?.label}
      </MenuButton>
      <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
        {SORT_OPTIONS.map(({ value, label }) => (
          <DropdownMenuItem
            key={value}
            value={value}
            selected={value === sortOrder}
            label={label}
            onClick={handleChangeSort(value)}
            sx={{ m: 0, minWidth: "150px" }}
          />
        ))}
      </Menu>
    </>
  );
};

export default TakeawaysSortMenu;
